module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_user-4a71b4fbf2bf4ccf7db6479fa6f1c5a8.svg";